import { ChevronDown } from "../../icons";

export function SmallDownIcon(props: any) {
  return <ChevronDown {...props} color="#636469" />;
}
